'use strict';

import { useEffect, useRef } from 'react';
import { requestPushPermission, sendPushNotification } from '../utils/pushNotifications';

// ── Singleton ────────────────────────────────────────────────────────────────
// Una sola conexión SSE compartida por toda la app.
let _es          = null;
let _listeners   = new Set();
let _retryTimer  = null;
let _hbInterval  = null;

function connectSSE() {
  const token = localStorage.getItem('hd_token');
  if (!token) return;
  if (_es && _es.readyState !== EventSource.CLOSED) return; // ya conectado

  _es = new EventSource(`/api/realtime/events?token=${token}`);

  _es.onmessage = (e) => {
    try {
      const data = JSON.parse(e.data);
      sendPushNotification(data);
      _listeners.forEach(fn => { try { fn(data); } catch {} });
    } catch {}
  };

  _es.onerror = () => {
    _es?.close();
    _es = null;
    clearTimeout(_retryTimer);
    _retryTimer = setTimeout(connectSSE, 5_000);
  };
}

function ensureHeartbeat() {
  if (_hbInterval) return;
  _hbInterval = setInterval(() => {
    const token = localStorage.getItem('hd_token');
    if (!token) return;
    fetch('/api/realtime/heartbeat', {
      method:  'POST',
      headers: { Authorization: `Bearer ${token}` },
    }).catch(() => {});
  }, 30_000);
}
// ────────────────────────────────────────────────────────────────────────────

/**
 * useRealtime(onEvent)
 * Se suscribe a los eventos SSE del servidor.
 * Todos los componentes comparten la misma conexión HTTP.
 */
export function useRealtime(onEvent) {
  const cbRef = useRef(onEvent);
  cbRef.current = onEvent;

  useEffect(() => { requestPushPermission(); }, []);

  useEffect(() => {
    const listener = (data) => cbRef.current?.(data);
    _listeners.add(listener);
    connectSSE();
    ensureHeartbeat();
    return () => _listeners.delete(listener);
  }, []);
}
